import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Menu.css';

const Menu: React.FC = () => {
  return (
    <section className="section menu">
      <meta name="google-site-verification" content="-3OTkhrHOCPlRzytSpxkqC08r3O4M8aOpN0h9XbZSnA" />
      <Helmet>
        <title className='padding-bottom: 10px'>燒石鼎 | 菜單</title>
        <meta name="description" content="查看燒石鼎的菜單，了解我們最新改良的船凍小卷鍋和巨霸海蝦叻沙鍋。" />
      </Helmet>
      <img src={require('../assets/menu-2.jpg')} alt="Hot Pot" className="hero-image" />
      {/* <h2>最新改良食材</h2>
      <ul>
        <li>船凍小卷鍋：小卷變大 🦑</li>
        <li>巨霸海蝦叻沙鍋：琥珀蝦改大白蝦 🦐</li>
      </ul>
      <p>還沒吃過的朋友可以嚐嚐！</p> */}
    </section>
  );
}

export default Menu;
